import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryStringCaseInsensitive from "@insite/client-framework/Common/Utilities/parseQueryStringCaseInsensitive";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { ButtonIcon } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import X from "@insite/mobius/Icons/X";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import OrderLinesList from "@WhiteCap/Overrides/Components/OrderLinesList";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";
import React, { useEffect, useRef, useState } from "react";
import { FC } from "react";
import { createPortal } from "react-dom";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => {
    const location = getLocation(state);
    let orderNumber;
    if (location && location.search) {
        const parsedQuery = parseQueryStringCaseInsensitive(location.search, {
            orderNumber: "",
        });
        orderNumber = parsedQuery.orderNumber;
    }
    const returnOrders = orderNumber ? state.WhiteCap.returnOrderStore.byOrderId[orderNumber]?.data || [] : [];
    const isLoadingReturnOrders = orderNumber
        ? state.WhiteCap.returnOrderStore.byOrderId[orderNumber]?.isLoading || false
        : false;

    return {
        pageType: getCurrentPage(state).type,
        returnOrders,
        isLoadingReturnOrders,
    };
};

export interface ReturnOrdersStyles {
    ReturnOrderWrapper?: InjectableCss;
    RefundTextWrapper?: InjectableCss;
    orderLinesListWrapper?: InjectableCss;
    returnOrderTitle?: TypographyProps;
    returnOrderTitle2?: TypographyProps;
    returnOrderText1?: TypographyProps;
    returnOrderText2?: TypographyProps;
    refundButton?: LinkPresentationProps;
    topContainer?: InjectableCss;
    parentWrapper?: InjectableCss;
    refundTotalWrapper?: InjectableCss;
    refundText?: InjectableCss;
    refundTotal?: InjectableCss;
    RefundTotalTextWrapper?: InjectableCss;
    refundTotalParentWrapper?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
}

export interface GroupedOrderLines {
    orderLine: OrderLineModel[];
    deliveryId?: string;
}

const returnOrdersStyles: ReturnOrdersStyles = {
    ReturnOrderWrapper: {
        css: css`
            background-color: #ecf7ed;
            padding: 24px 36px;
            display: flex;
            gap: 80px;
            align-items: flex-start;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 8px;
                        justify-content: space-between;
                        gap: 0px;
                    `,
                    css`
                        padding: 8px;
                        justify-content: space-between;
                        gap: 0px;
                    `,
                    css`
                        gap: 40px;
                    `,
                    null,
                    null,
                ])}
            +div {
                .borderBottom {
                    border-bottom: none !important;
                }
            }
        `,
    },
    RefundTextWrapper: {
        css: css`
            margin-left: auto;
            display: flex;
            margin-right: 80px;
            color: #2c6b32;
            font-size: 18px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-right: 0px;
                        margin-left: 0px;
                        font-size: 10px;
                        white-space: normal;
                        word-break: break-word;
                        max-width: 70px;
                    `,
                    css`
                        margin-right: 0px;
                        margin-left: 0px;
                        font-size: 10px;
                        white-space: normal;
                        word-break: break-word;
                        max-width: 70px;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    orderLinesListWrapper: {
        css: css`
            margin-bottom: 24px;
        `,
    },
    returnOrderTitle: {
        css: css`
            font-size: 18px;
            font-weight: 600;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 12px;
                    `,
                    css`
                        font-size: 12px;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },

    returnOrderTitle2: {
        css: css`
            font-size: 14px;
            font-weight: 400;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 10px;
                    `,
                    css`
                        font-size: 10px;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },

    returnOrderText1: {
        css: css`
            font-size: 16px;
            font-weight: 600;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 10px;
                    `,
                    css`
                        font-size: 10px;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    returnOrderText2: {
        css: css`
            font-size: 14px;
            font-weight: 400;
            text-align: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 10px;
                    `,
                    css`
                        font-size: 10px;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },

    refundButton: {
        css: css`
            color: #2f63b0;
            padding: 0px;
            background: none;
        `,
    },
    topContainer: {
        css: css`
            display: flex;
            justify-content: space-between;
            align-items: center;
        `,
    },
    parentWrapper: {
        css: css`
            width: 342px;
            height: 219px;
            border: 1px solid #f1f1f1;
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
            z-index: ${getProp("theme.zIndex.menu")};
            position: fixed;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            flex-direction: column;
            background-color: White;
        `,
    },
    refundTotalWrapper: {
        css: css`
            padding: 12px 40px;
            background-color: #f7f8f9;
            height: 128px;
        `,
    },
    refundText: {
        css: css`
            font-size: 14px;
        `,
    },
    refundTotal: {
        css: css`
            font-weight: 500;
        `,
    },

    RefundTotalTextWrapper: {
        css: css`
            padding: 16px 24px;
            display: flex;
            width: 100%;
            align-items: center;
            gap: 8px;
            justify-content: space-between; /* ensure title and close button are spaced */
        `,
    },

    refundTotalParentWrapper: {
        css: css`
            width: 100%;
            padding: 8px 15px;
            display: flex;
            flex-direction: column;
            gap: 8px;
        `,
    },
    centeringWrapper: {
        css: css`
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
};

const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
                gap: 0px;
            `,
            css`
                gap: 0px;
            `,
            css``,
            css``,
            css``,
        ])}
`;

const RefundTotalWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 5px;
    font-size: 14px;
`;

const styles = returnOrdersStyles;

type Props = ReturnType<typeof mapStateToProps>;

const ReturnOrders: FC<Props> = ({ returnOrders, isLoadingReturnOrders }) => {
    const [isMobile, setIsMobile] = useState(false);
    const [openOrderId, setOpenOrderId] = useState<string | null>(null);
    const triggerRef = useRef<Record<string, HTMLDivElement | null>>({});
    const modalRef = useRef<HTMLDivElement>(null);
    const hasClosed = useRef(false);
    const [alignCenter, setAlignCenter] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            setAlignCenter(window.innerWidth <= 500);
        };
        handleResize(); // check initially
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const updateModalPosition = () => {
        if (!openOrderId) {
            return;
        }

        const trigger = triggerRef.current[openOrderId];
        const modal = modalRef.current;

        if (!trigger || !modal) {
            return;
        }

        const triggerRect = trigger.getBoundingClientRect();
        const modalRect = modal.getBoundingClientRect();

        const gap = 8;
        const viewportW = window.innerWidth;
        const viewportH = window.innerHeight;

        // Prefer rendering above the trigger
        const desiredAboveTop = triggerRect.top - gap - modalRect.height;
        const desiredBelowTop = triggerRect.bottom + gap;
        let top: number;

        if (desiredAboveTop >= 8) {
            top = desiredAboveTop;
        } else if (desiredBelowTop + modalRect.height <= viewportH - 8) {
            top = desiredBelowTop;
        } else {
            // fallback: clamp above as best-effort
            top = Math.max(8, desiredAboveTop);
        }

        // Anchor left so modal's left edge sits slightly left of trigger (matches Image 2)
        let left: number;
        if (alignCenter) {
            left = viewportW / 2 - modalRect.width / 2;
        } else {
            left = triggerRect.left - 12;
        }

        // Horizontal clamp
        left = Math.max(8, Math.min(left, viewportW - modalRect.width - 8));

        // Apply styles directly
        modal.style.position = "fixed";
        modal.style.top = `${top}px`;

        if (alignCenter) {
            modal.style.left = "50%";
            modal.style.transform = "translateX(-50%)";
        } else {
            modal.style.left = `${left}px`;
            modal.style.transform = "";
        }
    };

    useEffect(() => {
        updateModalPosition();
    }, [openOrderId, alignCenter]);

    useEffect(() => {
        if (!openOrderId) {
            return;
        }

        const handleScroll = () => updateModalPosition();
        const handleResize = () => updateModalPosition();

        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);
        };
    }, [openOrderId]);

    // Close modal on outside click (ignore clicks on the trigger itself)
    useEffect(() => {
        const handleClickOutside = (event: PointerEvent) => {
            const target = event.target as Node;
            const modal = modalRef.current;
            const trigger = openOrderId ? triggerRef.current[openOrderId] : null;

            if (modal && !modal.contains(target) && trigger && !trigger.contains(target)) {
                if (!hasClosed.current) {
                    hasClosed.current = true;
                    setOpenOrderId(null);
                }
            }
        };

        if (openOrderId !== null) {
            document.addEventListener("pointerdown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("pointerdown", handleClickOutside);
            hasClosed.current = false;
        };
    }, [openOrderId]);

    // Close modal on ESC key
    useEffect(() => {
        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Escape") {
                setOpenOrderId(null);
            }
        };
        document.addEventListener("keydown", onKeyDown);
        return () => document.removeEventListener("keydown", onKeyDown);
    }, []);

    const refundText = isMobile ? "Refund in progress" : "Refund in progress...";

    const formatDate = (dateString?: string) => {
        if (!dateString) {
            return "—";
        }
        return new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        }).format(new Date(dateString));
    };

    return (
        <>
            {isLoadingReturnOrders && (
                <StyledWrapper {...styles.centeringWrapper}>
                    <LoadingSpinner {...styles.spinner} />
                </StyledWrapper>
            )}
            <div id="return-orders-section">
                {returnOrders?.map((order: any) => (
                    <React.Fragment key={order.erpOrderNumber}>
                        <StyledWrapper {...styles.ReturnOrderWrapper}>
                            <Section>
                                <Typography {...styles.returnOrderTitle}>RETURN #{order.erpOrderNumber}</Typography>
                                <Typography {...styles.returnOrderTitle2}>{order.statusDisplay}</Typography>
                            </Section>
                            <Section>
                                <Typography {...styles.returnOrderText1}>Return date</Typography>
                                <Typography {...styles.returnOrderText2}>{formatDate(order.orderDate)}</Typography>
                            </Section>
                            <Section>
                                <Typography {...styles.returnOrderText1}>Items</Typography>
                                <Typography {...styles.returnOrderText2}>{order.orderLines.length}</Typography>
                            </Section>
                            <StyledWrapper {...styles.RefundTextWrapper}>
                                {order?.status.toLowerCase() === "in progress" ? (
                                    <Typography {...styles.returnOrderText2}>{refundText}</Typography>
                                ) : (
                                    <>
                                        {openOrderId === order.erpOrderNumber &&
                                            createPortal(
                                                <StyledWrapper
                                                    ref={modalRef}
                                                    {...styles.parentWrapper}
                                                    role="dialog"
                                                    aria-modal="true"
                                                    aria-labelledby="modal-title"
                                                    onClick={e => e.stopPropagation()}
                                                    tabIndex={-1}
                                                >
                                                    <StyledWrapper {...styles.RefundTotalTextWrapper}>
                                                        <Typography>Refund total</Typography>
                                                        <ButtonIcon
                                                            src={X}
                                                            onClick={() => setOpenOrderId(null)}
                                                            aria-label="Close modal"
                                                        />
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.refundTotalParentWrapper}>
                                                        <StyledWrapper {...styles.refundTotalWrapper}>
                                                            <RefundTotalWrapper>
                                                                <Typography>SubTotal</Typography>
                                                                <Typography>{order?.orderSubTotalDisplay}</Typography>
                                                            </RefundTotalWrapper>
                                                            <RefundTotalWrapper>
                                                                <Typography>Tax</Typography>
                                                                <Typography>{order?.totalTaxDisplay}</Typography>
                                                            </RefundTotalWrapper>
                                                            <RefundTotalWrapper>
                                                                <Typography>Shipping</Typography>
                                                                <Typography>
                                                                    {order?.shippingAndHandlingDisplay}
                                                                </Typography>
                                                            </RefundTotalWrapper>
                                                            <RefundTotalWrapper>
                                                                <Typography {...styles.refundTotal}>Total</Typography>
                                                                <Typography {...styles.refundTotal}>
                                                                    {order?.orderGrandTotalDisplay}
                                                                </Typography>
                                                            </RefundTotalWrapper>
                                                        </StyledWrapper>
                                                        <Typography size={12} weight={400}>
                                                            Refunded to the original method of payment.
                                                        </Typography>
                                                    </StyledWrapper>
                                                </StyledWrapper>,
                                                document.body,
                                            )}
                                        <Link
                                            {...styles.refundButton}
                                            onClick={() => {
                                                setOpenOrderId(prev =>
                                                    prev === order.erpOrderNumber ? null : order.erpOrderNumber,
                                                );
                                            }}
                                        >
                                            <StyledWrapper
                                                ref={el => {
                                                    triggerRef.current[order.erpOrderNumber] = el;
                                                }}
                                            >
                                                <Typography>{translate("View refund")}</Typography>
                                            </StyledWrapper>
                                        </Link>
                                    </>
                                )}
                            </StyledWrapper>
                        </StyledWrapper>
                        <StyledWrapper {...styles.orderLinesListWrapper}>
                            {order && <OrderLinesList order={order} orderLines={order?.orderLines || []} />}
                        </StyledWrapper>
                    </React.Fragment>
                ))}
            </div>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ReturnOrders),
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage", "CustomOrderStatusPage"],
        group: "Order Details",
        displayName: "Return Orders",
    },
};

export default widgetModule;
